import {
  QA_COLLECTION_ADD,
  QA_COLLECTION_SUCCESS,
  QA_COLLECTION_FAIL,
  QA_GET_COLLECTION_LISTING,
  QA_GET_COLLECTION_LISTING_SUCCESS,
  QA_GET_COLLECTION_LISTING_FAILED,
  QA_COLLECTION_EDIT,
  QA_COLLECTION_EDIT_SUCCESS,
  QA_COLLECTION_EDIT_FAIL,
  QA_COLLECTION_UPDATE,
  QA_COLLECTION_UPDATE_SUCCESS,
  QA_COLLECTION_UPDATE_FAIL,
  QA_COLLECTION_DELETE,
  QA_COLLECTION_DELETE_SUCCESS,
  QA_COLLECTION_DELETE_FAIL,
  QA_EXPORTCOLLECTIONCATALOG_DOWNLOAD,
  QA_EXPORTCOLLECTIONCATALOG_DOWNLOAD_SUCCESS,
  QA_EXPORTCOLLECTIONCATALOG_DOWNLOAD_FAIL,
  QA_COLLECTION_COPY,
  QA_COLLECTION_COPY_SUCCESS,
  QA_COLLECTION_COPY_FAIL,
  QA_EXPORTDOWNLOAD_PROGRESS,
  QA_EXPORTDOWNLOAD_PROGRESS_SUCCESS,
  QA_EXPORTDOWNLOAD_PROGRESS_FAIL,
  QA_ADD_MORE_TO_COLLECTION,
  QA_ADD_MORE_TO_COLLECTION_SUCCESS,
  QA_ADD_MORE_TO_COLLECTION_FAIL,
  QA_ADD_MORE_TO_COLLECTION_UPDATE,
  QA_ADD_MORE_TO_COLLECTION_UPDATE_SUCCESS,
  QA_ADD_MORE_TO_COLLECTION_UPDATE_FAIL,
  QA_GET_PRODUCTS_FOR_ADD_COLLECTION,
  QA_GET_PRODUCTS_FOR_ADD_COLLECTION_SUCCESS,
  QA_GET_PRODUCTS_FOR_ADD_COLLECTION_FAIL,
  QA_GET_PRODUCT_OFFER_FOR_ADD_COLLECTION,
  QA_GET_PRODUCT_OFFER_FOR_ADD_COLLECTION_SUCCESS,
  QA_GET_PRODUCTS_OFFER_FOR_ADD_COLLECTION_FAIL,
  QA_REFRESH_COLLECTION_COUNT,
  QA_REFRESH_COLLECTION_COUNT_SUCCESS,
  QA_REFRESH_COLLECTION_COUNT_FAIL,
} from "./actionTypes"

const initialState = {
  error: null,
  loading: false,
  msg: null,
  collection: null,
  collectionEdit: null,
  collectionUpdate: null,
  collectionDelete: null,
  exportCollection: null,
  collectionCopy: null,
  qaExportDownloadProgress: null,
  collectionAddMore: null,
  addMoreUpdateDetails: null,
  productsForAddCollection: null,
  productsOfferForAddCollection: null,
}

export const qaCollection = (state = initialState, action) => {
  switch (action.type) {
    case QA_COLLECTION_ADD:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collection: action.payload,
      }
      break
    case QA_COLLECTION_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        collectionEdit: null,
        collectionUpdate: null,
        collectionDelete: null,
        exportCollection: null,
        collectionCopy: null,
        collectionAddMore: null,
        collection: action.payload,
      }
      break
    case QA_COLLECTION_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        collectionEdit: null,
        collectionUpdate: null,
        collectionDelete: null,
        exportCollection: null,
        collectionCopy: null,
        collectionAddMore: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case QA_GET_COLLECTION_LISTING:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collectionEdit: null,
        collectionUpdate: null,
        collectionDelete: null,
        exportCollection: null,
        collectionCopy: null,
        collectionAddMore: null,
        collection: action.payload,
      }
      break
    case QA_GET_COLLECTION_LISTING_SUCCESS:
      state = {
        ...state,
        error: null,
        loading: false,
        msg: null,
        collectionAddMore: null,
        collection: action.payload,
      }
      break
    case QA_GET_COLLECTION_LISTING_FAILED:
      state = {
        ...state,
        loading: false,
        msg: null,
        collectionAddMore: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case QA_COLLECTION_EDIT:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collectionEdit: action.payload,
      }
      break
    case QA_COLLECTION_EDIT_SUCCESS:
      if (state === null || state.collection.length === 0) {
        state = {
          ...state,
          loading: false,
          error: null,
          msg: null,
          collection: [...state.collection, action.payload],
        }
      } else {
        state = {
          ...state,
          loading: false,
          collection: state.collection.map(i =>
            i.id === action.payload.id ? action.payload : i
          ),
        }
      }
      break
    case QA_COLLECTION_EDIT_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case QA_COLLECTION_UPDATE:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collectionUpdate: action.payload,
      }
      break
    case QA_COLLECTION_UPDATE_SUCCESS:
      state = { ...state, error: null, msg: null, loading: false }
      break
    case QA_COLLECTION_UPDATE_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case QA_COLLECTION_DELETE:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collectionDelete: action.payload,
      }
      break
    case QA_COLLECTION_DELETE_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        collection: state.collection.filter(collection => {
          return collection.id !== action.payload.id
        }),
      }
      break
    case QA_COLLECTION_DELETE_FAIL:
      return {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case QA_EXPORTCOLLECTIONCATALOG_DOWNLOAD:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        exportCollection: action.payload,
      }
      break
    case QA_EXPORTCOLLECTIONCATALOG_DOWNLOAD_SUCCESS:
      state = {
        ...state,
        error: null,
        loading: false,
        msg: null,
        exportCollection: action.payload,
      }
      break
    case QA_EXPORTCOLLECTIONCATALOG_DOWNLOAD_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case QA_COLLECTION_COPY:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collectionCopy: action.payload,
      }
      break
    case QA_COLLECTION_COPY_SUCCESS:
      let newcol = [...state.collection, action.payload]
      newcol = newcol.sort(function (a, b) {
        return b.id - a.id || b.id.localeCompare(a.id)
      })
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        collection: newcol,
        collectionCopy: null,
      }
      break
    case QA_COLLECTION_COPY_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case QA_EXPORTDOWNLOAD_PROGRESS:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        qaExportDownloadProgress: action.payload,
      }
      break
    case QA_EXPORTDOWNLOAD_PROGRESS_SUCCESS:
      state = {
        ...state,
        error: null,
        loading: false,
        msg: null,
        qaExportDownloadProgress: action.payload,
      }
      break
    case QA_EXPORTDOWNLOAD_PROGRESS_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case QA_ADD_MORE_TO_COLLECTION:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        collectionAddMore: action.payload,
      }
      break
    case QA_ADD_MORE_TO_COLLECTION_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        collectionAddMore: action.payload,
      }
      break
    case QA_ADD_MORE_TO_COLLECTION_FAIL:
      return {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case QA_ADD_MORE_TO_COLLECTION_UPDATE:
      state = {
        ...state,
        loading: true,
        msg: null,
        error: null,
        addMoreUpdateDetails: action.payload,
      }
      break
    case QA_ADD_MORE_TO_COLLECTION_UPDATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: null,
        addMoreUpdateDetails: null,
      }
      break
    case QA_ADD_MORE_TO_COLLECTION_UPDATE_FAIL:
      return {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case QA_GET_PRODUCTS_FOR_ADD_COLLECTION:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        productsForAddCollection: action.payload,
      }
      break
    case QA_GET_PRODUCTS_FOR_ADD_COLLECTION_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        productsForAddCollection: action.payload,
      }
      break
    case QA_GET_PRODUCTS_FOR_ADD_COLLECTION_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        productsForAddCollection: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
    case QA_GET_PRODUCT_OFFER_FOR_ADD_COLLECTION:
      state = {
        ...state,
        loading: true,
        error: null,
        msg: null,
        productsForAddCollection: null,
        productsOfferForAddCollection: action.payload,
      }
      break
    case QA_GET_PRODUCT_OFFER_FOR_ADD_COLLECTION_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
        msg: null,
        productsOfferForAddCollection: action.payload,
      }
      break
    case QA_GET_PRODUCTS_OFFER_FOR_ADD_COLLECTION_FAIL:
      state = {
        ...state,
        loading: false,
        msg: null,
        error: action.payload !== "light" ? action.payload : "",
      }
      break
      case QA_REFRESH_COLLECTION_COUNT:
        state = {
          ...state,
          loading: true,
          error: null,
          msg: null,
          productsForAddCollection: null,
          productsOfferForAddCollection: action.payload,
        }
        break
      case QA_REFRESH_COLLECTION_COUNT_SUCCESS:
        state = {
          ...state,
          loading: false,
          error: null,
          msg: null,
          collection: state.collection.map(i =>
            i.id === action.payload.id ? action.payload : i
          ),
        }
        break
      case QA_REFRESH_COLLECTION_COUNT_FAIL:
        state = {
          ...state,
          loading: false,
          msg: null,
          error: action.payload !== "light" ? action.payload : "",
        }
  }
  return state
}

export default qaCollection
